export const isDev = process.env.NODE_ENV === 'development';
export const isStaging = process.env.VUE_APP_IS_STAGING === 'true';
export const base =
    isDev ? 'https://localhost:6001/'
        : isStaging
        ? 'https://fakeapps.ncut.edu.tw/ncutuni/'
        : 'https://ncutuni.ncut.edu.tw/';
export const app_name = process.env.VUE_APP_TITLE;
export const SystemKey = 'dd30719e95024be78a032933c1a02767';
export const TOKEN_KEY = `jwt_${SystemKey}`;
export const uploadUrl = `${base}api/gxbooking/upload`;
export const TotalPeriods = 16;
export const Semesters = [
    {
        text: '上學期',
        value: 1,
    },
    {
        text: '下學期',
        value: 2,
    },
    {
        text: '暑修1',
        value: 3,
    },
    {
        text: '暑修2',
        value: 4,
    },
    {
        text: '寒修',
        value: 5,
    }
];

export const ChangeStatus = {
    Success: 0,
    Existed: 1,
    FileError: 2
};


export const ReplaceTags = {
    Name: 1,
    ApplyDate: 2,
    DenyReason: 3,
    Url: 4,
    DenyAt: 5,
    FinishAt: 6,
    Results: 7
};

export const MailTemplateTypes = {
    Apply: {
        value: 9,
        label: '申請通知',
        availableReplaces: [ReplaceTags.Name, ReplaceTags.ApplyDate, ReplaceTags.Results]
    },
    Success: {
        value: 10,
        label: '申請核可通知',
        availableReplaces: [ReplaceTags.Name, ReplaceTags.ApplyDate, ReplaceTags.FinishAt, ReplaceTags.Results]
    },
    Deny: {
        value: 13,
        label: '退回通知',
        availableReplaces: [ReplaceTags.Name, ReplaceTags.ApplyDate, ReplaceTags.DenyReason, ReplaceTags.DenyAt]
    },
};
export const UploadTypes = {
    GXNewsAttaches: 2
};

export const IdentityTypes = {
    Employee: '0',
    Student: '1',
    Teacher: '2'
};

export const Weekdays = [
    '日', '一', '二', '三', '四', '五', '六', '日'
];

export const FormType = {
    Normal: 1,
    Super: 3,
    OnlyForMarking : 99
};
